import React from 'react';
import { HeroSection } from './components/HeroSection';
import { EmotionalSection } from './components/EmotionalSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { IncludesSection } from './components/IncludesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ForWhomSection } from './components/ForWhomSection';
import { PriceSection } from './components/PriceSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#FAF7F2]" data-id="element-0">
      {/* Top Bar */}
      <header className="w-full px-5 py-4 border-b border-[#B8A99A]/15" data-id="element-1">
        <div className="max-w-3xl mx-auto" data-id="element-2">
          <span className="text-lg font-semibold text-[#2C2825] tracking-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-3">
            Mapa de Ojeras™
          </span>
        </div>
      </header>

      <main data-id="element-4">
        {/* 1. Hero */}
        <HeroSection data-id="element-5" />

        {/* 3. Emotional Identification */}
        <EmotionalSection data-id="element-6" />

        {/* 4-5. Problem + Infographic */}
        <ProblemSection data-id="element-7" />

        {/* 6. Mechanism */}
        <MechanismSection data-id="element-8" />

        {/* 8-10. Includes + CTA #2 + Printables */}
        <IncludesSection data-id="element-9" />

        {/* 11. How It Works */}
        <HowItWorksSection data-id="element-10" />

        {/* 12. For Whom */}
        <ForWhomSection data-id="element-11" />

        {/* 14. FAQ */}
        <FAQSection data-id="element-12" />

        {/* 15. Price Section */}
        <PriceSection id="precio-final" data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}